import { styled } from '@tools/wr-catalog-base'

export const Wrapper = styled.div`
  margin-top: 30px;

  .product-details-add-to-order {
    display: none;
  }
`
